import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { InvitesManager } from "@/features/admin/components/invites-manager";
import { PageContainer } from "@/components/ui/page-container";

function AdminInvitesPage() {
  return (
    <PageContainer maxWidth="4xl">
      <InvitesManager />
    </PageContainer>
  );
}

export const adminInvitesRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/invites",
  component: AdminInvitesPage,
});
